﻿import {UIText} from "../Tools/Base/UIText";
import {UINineSlice} from "../Tools/Base/UINineSlice";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {UISprite} from "../Tools/Base/UISprite";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";
import {Core} from "../../Base/Core";

class NewEpochImage extends UISprite {
    Awake() {
        super.Awake();
        this.back = this.addChild(new UISprite());
        this.back.mask = this.back.addChild(new PIXI.Graphics().beginFill(0xffffff, 1).drawRect(0, 0, 1, 1));
        this.creatures = [];
        for (let i = 0; i < 3; i++) {
            this.creatures.push(this.back.addChild(new UISprite()));
        }
    }

    Init(epochId) {
        super.Init();
        this.back.setImage(`epochs/${epochId}`);
        let creatures = Core.GameData.Epochs.GetById(epochId).creatures.slice(0, this.creatures.length);
        for (let i = 0; i < this.creatures.length; i++) {
            this.creatures[i].SetActive(i < creatures.length);
            if (this.creatures[i].Active) {
                this.creatures[i].setImage(`creatures/${creatures[i]}`);
            }
        }
    }

    fitLayout(rect) {
        this.back.fitRect(rect, true);
        this.back.mask.width = rect.width / this.back.scale.x;
        this.back.mask.height = rect.height / this.back.scale.y;
        this.back.mask.position.set((-rect.width * 0.5) / this.back.scale.x, (-rect.height * 0.5) / this.back.scale.y);

        let creatures = this.creatures.filter((c) => c.Active);

        let getScale = (creature, { w, h }) => {
            return Math.min(w / creature.texture.width / this.back.scale.x, h / creature.texture.height / this.back.scale.x);
        };

        if (creatures.length > 1) {
            // Distribute creatures
            let w = (this.back.width * 0.5) / this.back.scale.x,
                h = (this.back.height * 0.5) / this.back.scale.x;

            creatures[0].position.set(-w * 0.5, h * 0.16);
            creatures[0].scale.set(getScale(creatures[0], { w: rect.width * 0.35, h: rect.height * 0.45 }));

            creatures[1].position.set(-w * 0.15, -h * 0.15);
            creatures[1].scale.set(getScale(creatures[1], { w: rect.width * 0.3, h: rect.height * 0.4 }));

            creatures[2].position.set(w * 0.45, h * 0.07);
            creatures[2].scale.set(getScale(creatures[2], { w: rect.width * 0.5, h: rect.height * 0.6 }));
        } else {
            // Boss. Center.
            creatures[0].position.set(0, 0);
        }
    }
}

class EpochBadge extends UISprite {
    Awake() {
        this.setImage("btn-circle-green");
        this.icon = this.addChild(new UISprite());
    }

    Init(epochId, isCurrent = false) {
        this.setImage(isCurrent ? "btn-circle-blue" : "btn-circle-green");
        this.icon.setImage(`epochs/icons/${epochId}`);
    }

    fitLayout(rect) {
        this.scale.set(Math.min(rect.width / this.texture.width, rect.height / this.texture.height));
        this.position.set(rect.x + rect.width * 0.5, rect.y + rect.height * 0.5);
        this.icon.scale.set((this.texture.width * 0.8) / this.icon.texture.width);
    }
}

class EpochProgressItem extends UISprite {
    Awake() {
        this.epochBadge = this.addChild(new EpochBadge());
        this.marker = this.addChild(new UINineSlice("bg-bar"));
        this.creature = this.addChild(new UISprite(""));
    }

    Init(epochId, progressPosition) {
        let epochsList = Core.GameData.Epochs.GetEpochsList(epochId);
        let epochData = Core.GameData.Epochs.GetById(epochId);
        let isNew = epochId == epochsList[progressPosition];
        let alreadyOpened = progressPosition >= epochsList.indexOf(epochId);

        this.epochBadge.SetActive(alreadyOpened);
        this.creature.SetActive(alreadyOpened);

        if (alreadyOpened) {
            this.epochBadge.Init(epochId, isNew);
            this.creature.setImage("creatures/" + epochData.creatures[0]);
            this.marker.tint = 0x00ff00;
            this.marker.alpha = isNew ? 1 : 0.3;
        } else {
            // Not opened
            this.marker.tint = 0x000000;
            this.marker.alpha = 0.5;
        }
    }

    fitLayout(rect) {
        this.position.set(rect.x, rect.y);

        let tmpRect = rect.clone();
        tmpRect.width = rect.width * 0.9;
        tmpRect.height = rect.height * 0.42;
        tmpRect.y = 0;
        tmpRect.x = (rect.width - tmpRect.width) * 0.5;
        this.epochBadge.fitLayout(tmpRect);

        tmpRect = rect.clone();
        tmpRect.height = rect.height * 0.08;
        tmpRect.width = rect.width * 0.95;
        tmpRect.y = (rect.height - tmpRect.height) * 0.52;
        tmpRect.x = (rect.width - tmpRect.width) * 0.5;
        this.marker.fitLayout(tmpRect);

        tmpRect = rect.clone();
        tmpRect.height = rect.height * 0.4;
        tmpRect.width = rect.width * 0.9;
        tmpRect.y = (rect.height - tmpRect.height) * 1;
        tmpRect.x = (rect.width - tmpRect.width) * 0.5;
        this.creature.fitRect(tmpRect);
    }
}

class EpochProgress extends UISprite {
    Awake() {
        this.markers = [];
    }

    Init(epochId) {
        let currentEpochData = Core.GameData.Epochs.GetById(epochId);
        let epochsList = Core.GameData.Epochs.GetEpochsList(epochId);
        let indexOfNewEpoch = epochsList.indexOf(currentEpochData.id);

        // Add markers if needed
        while (this.markers.length < epochsList.length) {
            let marker = this.addChild(new EpochProgressItem());
            this.markers.push(marker);
        }
        // Remove redundant markers
        while (this.markers.length > epochsList.length) {
            let marker = this.markers.pop();
            if (marker.parent) marker.parent.removeChild(parent);
        }

        for (let i = 0; i < epochsList.length; i++) {
            this.markers[i].Init(epochsList[i], indexOfNewEpoch);
        }
    }

    fitLayout(rect) {
        this.position.set(rect.x, rect.y);

        let markerRect = rect.clone();
        markerRect.x = 0;
        markerRect.y = 0;
        markerRect.width = rect.width / (this.markers.length || 1);

        for (let marker of this.markers) {
            marker.fitLayout(markerRect);
            markerRect.x += markerRect.width;
        }
    }
}

export class UINewEpoch extends UICommonPopup {
    Awake() {
        super.Awake();

        this.epochImage = this.content.addChild(new NewEpochImage());

        this.title = this.content.addChild(new UIText(Core.Localizator.Get("new_epoch")));

        this.epochName = this.content.addChild(new UIText(""));

        this.epochProgress = this.content.addChild(new EpochProgress());

        this.hardMoneyObject = this.content.addChild(new UISprite()); // Transform hardMoneyObject;

        this.okBtn = this.content.addChild(new UINineSliceButton("btn-green", { label: Core.Localizator.Get("ok") }));

        this.epochId = 0;
    }

    Init() {
        super.Init();
        this.okBtn.on("pointertap", () => this.Hide());
    }

    fitLayout(viewport = Core.app.viewport) {
        super.fitLayout(viewport);

        let sideRatio = 1.6;
        let w = Math.min(viewport.width * 0.85, (viewport.height * 0.85) / sideRatio);
        let h = w * sideRatio;

        this.setPopupRect(new PIXI.Rectangle((viewport.width - w) * 0.5, (viewport.height - h) * 0.5, w, h));

        let popupRect = this.getContentSize();

        let rect = popupRect.clone();
        rect.height = popupRect.height * 0.13;
        rect.width = popupRect.width * 0.7;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.01;
        this.title.fitLayout(rect);

        rect.height = popupRect.height * 0.38;
        rect.width = popupRect.width * 0.8;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.25;
        this.epochImage.fitLayout(rect);

        rect = popupRect.clone();
        rect.height = popupRect.height * 0.07;
        rect.width = popupRect.width * 0.7;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.59;
        this.epochName.fitLayout(rect);

        rect = popupRect.clone();
        rect.height = popupRect.height * 0.2;
        rect.width = popupRect.width * 0.9;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.79;
        this.epochProgress.fitLayout(rect);

        rect = popupRect.clone();
        rect.width = popupRect.width * 0.45;
        rect.height = popupRect.height * 0.12;
        rect.x = (popupRect.width - rect.width) * 0.5;
        rect.y = (popupRect.height - rect.height) * 0.97;
        this.okBtn.fitLayout(rect);
    }

    Show(epochId = null) {
        this.updateUI(epochId);
        Core.Audio.Play("NewEpoch");
        super.Show();
    }

    Hide() {
        super.Hide();
        Core.WaitBefore(0.5, () => {
            Core.Player.PlanetsSave.CurrentPlanet.firstCreatureOffer(this.epochId);
        });
    }

    updateUI(epochId = this.epochId) {
        let newEpochData = Core.GameData.Epochs.GetById(epochId);
        if (newEpochData) {
            this.epochId = epochId;
            this.epochImage.Init(newEpochData.id);
            this.epochName.text = Core.Localizator.Get(newEpochData.epochName);
            this.epochProgress.Init(newEpochData.id);
        }
        this.fitLayout();
    }
}
